// extracted by mini-css-extract-plugin
export default {"inputs":"AddEditCutOffTime_inputs__oAcnK","icon":"AddEditCutOffTime_icon__muazy","buttons":"AddEditCutOffTime_buttons__igQvd"};